__webpack_require__.p = "https://frontend-apps-multi-region.workos.com/apps/docs/production/_next/";